interface FormDividerProps {
  text?: string;
  className?: string;
}

export const FormDivider = ({ text = 'or', className = '' }: FormDividerProps) => {
  return (
    <div className={`my-[20px] flex h-[16px] items-center justify-center gap-[18px] ${className}`}>
      <div className="h-px flex-1 bg-[#E0E0E0]" />
      <span className="text-[16px] font-medium leading-[100%] text-[#D4D4D4]">{text}</span>
      <div className="h-px flex-1 bg-[#E0E0E0]" />
    </div>
  );
};
